import { render, staticRenderFns } from "./Rented.vue?vue&type=template&id=594bfcdf&"
import script from "./Rented.vue?vue&type=script&lang=ts&"
export * from "./Rented.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports